import { Box } from '@mui/material'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  makeStyles
} from '@material-ui/core'
import React from 'react'
import ProgressButton from 'components/ProgressButton'

const ConfirmModal = (props) => {
  const classes = useStyles()
  const {
    closeModal,
    dialogTitle,
    open,
    dialogText,
    dialogText2 = '',
    inProgress,
    handleConfirm
  } = props
  const onConfirm = async () => {
    await handleConfirm()
    if (!inProgress) {
      closeModal()
    }
  }

  return (
    <div>
      <Dialog
        fullWidth
        aria-describedby="alert-dialog-description"
        aria-labelledby="alert-dialog-title"
        maxWidth="xs"
        open={open}>
        <DialogTitle id="alert-dialog-title" variant="h6">
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.text}>{dialogText}</DialogContentText>
          {dialogText2 && (
            <DialogContentText className={classes.text}>{dialogText2}</DialogContentText>
          )}
          <Box className={classes.btnBox}>
            <Button color="inherit" onClick={closeModal} disabled={inProgress}>
              No
            </Button>
            <ProgressButton
              label="YES"
              inProgress={inProgress}
              disabled={inProgress}
              onClick={onConfirm}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  )
}
export default ConfirmModal

const useStyles = makeStyles({
  btnBox: {
    marginTop: '1.5rem',
    display: 'flex',
    justifyContent: 'right',
    gap: '0.5rem',
    marginBottom: '0.5rem'
  },
  yesBtn: {
    color: 'white'
  },
  text: {
    marginBottom: '8px'
  }
})
